import axios from "axios";
import dayjs from "dayjs";
const baseURL: any = process.env.REACT_APP_API_URL;

export function validarContadoCredito(cedula: string) {
  return axios
    .get(`${baseURL}/validar/${cedula}/contado-credito`)
    .then(({ data }) => data);
}

export function validarCupoDemanda(data: any) {
  return axios
    .post(`${baseURL}/comandos/validar/cupo-demanda`, data)
    .then(({ data }) => data);
}

export function getDatosContadoCredito(cedula: string) {
  return axios.get(`${baseURL}/recuperar/${cedula}/contado-credito`).then(({ data }) => {
    const dataUser = data.usuario;
    const [primerNombre, segundoNombre] = data.usuario.nombres.split(" ");
    dataUser.numeroDocumento = cedula;
    dataUser.primerNombre = primerNombre;
    dataUser.segundoNombre = segundoNombre ?? "";
    dataUser.fechaNacimiento = data.usuario.fechaNacimiento
      ? dayjs(data.usuario.fechaNacimiento)
      : null;
    dataUser.fechaExpedicionDocumento = data.usuario.fechaExpedicionDocumento
      ? dayjs(data.usuario.fechaExpedicionDocumento)
      : null;
    dataUser.phone = data.contacto.telefonoPrincipal;
    dataUser.email = data.contacto.correoElectronico;
    return dataUser;
  });
}

export const procesarContadoCredito = (datosUsuario: any) => {
  return axios
    .post(`${baseURL}/comandos/iniciar/contado-credito`, datosUsuario)
    .then(({ data }) => data);
};
